import { Accordion, AccordionTab } from "primereact/accordion";
import { Button } from "primereact/button";
import React, { useContext } from "react";
import CardSeplag from "../../../../../components/CardSeplag";
import AnalisePPDCOFD from "./AnalisePPDCOFD";
import { AvaliacaoAcaoContext } from "./AvaliacaoAcaoContext";
import { AccordionEficiencia, AccordionFinanceiro } from "./AccordionQuestionario";
import OrcamentoFinanceiro from "./OrcamentoFinanceiro";
import NewAnalisePPDCOFD from "./NewAnalisePPDCOFD";
const AvaliacaoAcaoConsumerContent = ({ props }) => {
  const { salvar, voltar } = useContext(AvaliacaoAcaoContext);

  const viewPPa = () => {
    if (props.dadosItemAcao.ptaFiplan.exercicio.ano > 2023) {
      return (
        <Accordion multiple>
          <AccordionTab header="Realização Orçamentária e Financeira da Ação">
            <OrcamentoFinanceiro />
          </AccordionTab>

          <AccordionTab header="Análise do PPD e COFD">
            <NewAnalisePPDCOFD />
          </AccordionTab>
        </Accordion>
      );
    }
    return (
      <Accordion multiple>
        <AccordionTab header="Realização Orçamentária e Financeira da Ação">
          <OrcamentoFinanceiro />
        </AccordionTab>

        <AccordionTab header="Análise do PPD e COFD">
          <AnalisePPDCOFD />
        </AccordionTab>

        <AccordionTab header="Disponibilidade Financeira">
          <AccordionFinanceiro props={props} />
        </AccordionTab>
        <AccordionTab header="Eficiência">
          <AccordionEficiencia props={props} />
        </AccordionTab>
      </Accordion>
    );
  };

  return (
    <CardSeplag title="Execução Orçamentária">
      {viewPPa()}

      <br />
      <br />
      <div className="p-fluid grid">
        <div className="field col-12 md:col-8 ">&nbsp;</div>
        <div className="field col-12 md:col-2 ">
          <Button label="Voltar" className="p-button-secondary" onClick={voltar} />
        </div>
        <div className="field col-12 md:col-2 ">
          <Button label="Salvar" className="p-button-success" onClick={salvar} disabled={!props.podeAvaliarAcao} />
        </div>
      </div>
    </CardSeplag>
  );
};

export default AvaliacaoAcaoConsumerContent;
